module.exports = __webpack_public_path__ + "img/ticket-blue.0e693357.png";